import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "sf_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (item) => {
    setItems((cur) => [...cur, { ...item, cart_id: crypto.randomUUID() }]);
  };
  const removeItem = (cart_id) => setItems((cur) => cur.filter((i) => i.cart_id !== cart_id));
  const clearCart = () => setItems([]);

  const totals = useMemo(() => {
    const subtotal = Math.round(items.reduce((s, i) => s + (i.line_total || 0), 0) * 100) / 100;
    const gst = Math.round(subtotal * 10) / 100;
    const shipping = 0;
    const total = Math.round((subtotal + gst) * 100) / 100;
    const count = items.reduce((s, i) => s + (i.quantity ? 1 : 0), 0);
    return { subtotal, gst, shipping, total, count };
  }, [items]);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clearCart, totals }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
